import { useState } from "react";

const EuropeanAirFreight = () => {
 
    const [openIndex, setOpenIndex] = useState(null);
  
    const toggleFAQ = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };
  const faqs = [
    {
      question: "How long does road transport to Europe take?",
      answer: "Delivery times vary depending on the origin and destination, typically ranging from a few days to a couple of weeks.",
    },
    {
      question: "Do you handle customs clearance for European shipments?",
      answer: "Yes, we take care of all customs documentation and clearance processes to ensure smooth cross-border transport.",
    },
    {
      question: "What types of goods can be transported to Europe?",
      answer: "We transport a wide range of cargo, including general goods, perishables, hazardous materials, and oversized freight, following all necessary regulations.",
    },
    {
      question: "How can I get a transport quote?",
      answer: "You can request a quote by filling out our online form or contacting our customer support team for detailed pricing and service options.",
    },
  ];
  
    return (
      <div className="w-full">
        
        {/* Hero Section */}
        <div
          className="relative w-full h-screen bg-cover bg-center flex items-center justify-center text-white"
          style={{ backgroundImage: "url('/images/europeanbg.jpg')" }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative text-center md:px-6">
            <h1 className="text-4xl md:text-6xl lg:text-8xl font-semibold">Europe Transport Services</h1>
            <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            Reliable and efficient road transport solutions for businesses across Europe, ensuring seamless logistics for time-sensitive shipments with flexible and cost-effective delivery options.
            </p>
            <a
              href="/contactus"
              className="mt-6 inline-block bg-white hover:bg-gray-300 text-black px-6 py-3 text-lg font-semibold  transition"
            >
              Get a Free Quote
            </a>
          </div>
        </div>
  
        {/* About Our Services */}
      {/* Why Choose Us Section */}
      <section className="max-w-6xl mx-auto px-3 md:px-6 py-16 text-center">
  <h2 className="text-3xl md:text-4xl font-thin text-gray-800">Why Choose Our Road Transport Services to Europe?</h2>
  <p className="text-gray-600 text-xl font-thin mt-4 max-w-3xl mx-auto">
    We provide secure, cost-effective, and efficient road transport solutions from various global locations to Europe, ensuring smooth and timely deliveries.
  </p>

  {/* Benefits Section */}
  <div className="grid md:grid-cols-3 gap-12 mt-12 text-left">
    <div className="flex items-start space-x-4">
      <div>
        <h3 className="text-2xl font-thin text-gray-800">Timely & Reliable Deliveries</h3>
        <p className="text-gray-600 mt-2 text-xl font-thin">With a strong logistics network, we guarantee on-time shipments to destinations across Europe.</p>
      </div>
    </div>

    <div className="flex items-start space-x-4">
      <div>
        <h3 className="text-2xl font-thin text-gray-800">Extensive European Reach</h3>
        <p className="text-gray-600 mt-2 text-xl font-thin">We deliver to all major European cities and remote locations with seamless coordination.</p>
      </div>
    </div>

    <div className="flex items-start space-x-4">
      <div>
        <h3 className="text-2xl font-thin text-gray-800"> Customs Clearance</h3>
        <p className="text-gray-600 mt-2 text-xl font-thin">Our team handles all documentation and compliance requirements for smooth cross-border transport.</p>
      </div>
    </div>
  </div>
</section>

  
<div className="flex flex-col lg:flex-row items-center p-4  md:p-8  justify-center space-y-6 md:space-y-0 md:gap-10 xl:gap-40 xl:mt-20">
          <div className="lg:w-1/2 2xl:w-1/3 flex justify-center">
            <img 
              src="images/europecase.webp" 
              alt="Freight Platform" 
              className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
   <p className=" text-xl  md:text-2xl  font-thin text-justify max-w-xl md:leading-10 text-gray-600">
   When speed and efficiency are crucial, our road transport services to Europe guarantee timely and reliable deliveries. We specialize in seamless cross-border logistics, ensuring smooth and hassle-free transportation of goods across European destinations. With a strong network of trusted carriers and expert handling, we provide secure and cost-effective solutions for businesses of all sizes. Whether it's general cargo,
    perishables, or specialized freight, we ensure your shipments arrive safely and on schedule.
   </p>
          </div>
        </div>
  
       
        <div className="flex flex-col lg:flex-row items-center p-4  md:p-8  justify-center space-y-6 md:space-y-0 md:gap-10 xl:gap-40 xl:mt-20">
        <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
        <p className="text-xl md:text-2xl font-thin text-justify max-w-xl md:leading-10 text-gray-600">
  Ensure smooth and timely deliveries with our expert road transport services to Europe.  
  We provide seamless logistics solutions, ensuring your cargo reaches its destination efficiently and securely.  
  With a strong network of reliable transport partners, we handle shipments of all sizes, offering cost-effective and dependable freight services tailored to your business needs.
</p>

          </div>
          <div className="lg:w-1/2 2xl:w-1/3 flex justify-center">
            <img 
              src="images/europecase1.webp" 
              alt="Freight Platform" 
              className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
            />
          </div>
          
        </div>


         {/* FAQ Section */}
         <section className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-thin text-gray-800 text-center">Frequently Asked Questions</h2>
        <p className="text-gray-600 text-lg mt-4 max-w-3xl mx-auto font-thin text-center">
          Here are some of the most common questions about our road transport services to Europe.
        </p>

        {/* FAQ Items */}
        <div className="mt-10 space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md cursor-pointer transition hover:shadow-lg"
              onClick={() => toggleFAQ(index)}
            >
              <div className=" text-xl md:text-2xl font-thin text-gray-800 flex justify-between">
                {faq.question}
                <span className={`text-gray-500 text-lg transition ${openIndex === index ? "rotate-180" : ""}`}>&#9660;</span>
              </div>
              {openIndex === index && <p className="text-gray-600 text-xl font-thin mt-2">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>

       {/* Call to Action */}
       <section className="relative  bg-cover  bg-no-repeat w-full  py-36 mt-20" style={{ backgroundImage: "url('images/contactus1.jpg') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 container mx-auto text-center font-thin text-white px-6">
          <h2 className="text-3xl md:text-[45px] mb-6">
  Contact us to learn more about our European road transportation solutions.
</h2>

            <div className=" flex justify-center">
            </div>
          
            <a
              href="/contactus"
              className="inline-block bg-gray-200 text-black  px-8 py-2 md:py-3 uppercase shadow-lg hover:bg-slate-800 hover:text-white transition duration-300"
            >
              Contact Us
            </a>
          </div>
        </section>
      </div>
    );
  };
  
  export default EuropeanAirFreight;
  